import moment from "moment";
import { EthiopianDateUtil } from "mui-ethiopian-datepicker";

// Ethiopian month names
const ETHIOPIAN_MONTHS = [
  "መስከረም",
  "ጥቅምት",
  "ህዳር",
  "ታኅሣሥ",
  "ጥር",
  "የካቲት",
  "መጋቢት",
  "ሚያዝያ",
  "ግንቦት",
  "ሰኔ",
  "ሐምሌ",
  "ነሐሴ",
  "ጳጉሜ"
];

export const getEthiopianDateWithMonthNames = (date, format = "short") => {
  if (!date) return "";

  try {
    const ethiopianDate = EthiopianDateUtil.toEth(moment(date).toDate());
    const day = ethiopianDate.Day;
    const monthNumber = ethiopianDate.Month;
    const year = ethiopianDate.Year;

    // Get month name (month numbers are 1-based)
    const monthName = ETHIOPIAN_MONTHS[monthNumber - 1] || monthNumber;

    if (format === "short") {
      // Returns: "25 Meskerem 2016"
      return `${day} ${monthName} ${year}`;
    } else if (format === "abbreviated") {
      // Returns: "25 Mes 2016"
      const abbreviatedMonth = monthName.substring(0, 3);
      return `${day} ${abbreviatedMonth} ${year}`;
    } else {
      // Default full format: "25 Meskerem 2016"
      return `${day} ${monthName} ${year}`;
    }
  } catch (error) {
    console.error("Error converting to Ethiopian date:", error);
    return date;
  }
};
